module.exports = __webpack_public_path__ + "static/media/integrity.410776c2.jpg";